/*
  Bilfilter for kolleksjon (tillegg)
  Begrenser bilfilteret til produkter i kolleksjonen seksjonen ligger i.
  Endrer IKKE year-make-model.js. Lastes FOER year-make-model.js og kobler seg paa
  instansen i det oeyeblikket den opprettes (window._pfInstance).
  Gjelder kun seksjoner som har data-collection-id.
*/
(function () {
  var root = document.querySelector('[data-partfinder][data-collection-id]');
  if (!root) return;

  var collectionId = root.dataset.collectionId || '';
  if (!collectionId) return;

  var collectionTitle = root.dataset.collectionTitle || '';
  var scopeFilter = 'collection_ids:' + collectionId;

  function scopeParams(params) {
    var p = Object.assign({}, params || {});
    var ff = [];
    if (Array.isArray(p.facetFilters)) ff = p.facetFilters.slice();
    else if (p.facetFilters) ff = [p.facetFilters];
    ff.push([scopeFilter]);
    p.facetFilters = ff;
    return p;
  }

  /* Pakker inn Algolia-klienten uten aa endre originalen */
  function scopeClient(client) {
    if (!client || client.__pfScoped) return client;
    return {
      __pfScoped: true,
      initIndex: function (name) {
        var idx = client.initIndex(name);
        return {
          search: function (query, params) {
            return idx.search(query, scopeParams(params));
          }
        };
      }
    };
  }

  function patch(pf) {
    if (!pf || pf.__pfCollectionPatched || pf.root !== root) return;

    /* 1) Alle produktsoek faar kolleksjonsfilter, ogsaa hvis klienten lages paa nytt ved retry */
    var current = scopeClient(pf.productClient);
    Object.defineProperty(pf, 'productClient', {
      configurable: true,
      enumerable: true,
      get: function () { return current; },
      set: function (v) { current = scopeClient(v); }
    });
    if (current) pf.productIndex = current.initIndex(pf.config.productIndex);

    /* 2) Behold kolleksjonens egen URL (originalen bytter til /collections/all) */
    pf.buildFilterRedirectUrl = function (brand, model, year) {
      var params = new URLSearchParams();
      params.set('pf_brand', brand);
      params.set('pf_model', model);
      params.set('pf_year', year);
      return window.location.pathname + '?' + params.toString();
    };

    /* 3) Tydeligere tekst naar kolleksjonen ikke har produkter til bilen */
    if (collectionTitle && typeof pf.renderProducts === 'function') {
      var origRender = pf.renderProducts.bind(pf);
      pf.renderProducts = function (append) {
        origRender(append);
        var grid = pf.elements && pf.elements.resultsGrid;
        var el = grid ? grid.querySelector('.partfinder__empty-sorry') : null;
        if (el) el.textContent = 'Vi har dessverre ingen produkter til denne bilen i ' + collectionTitle + ' for \u00f8yeblikket.';
      };
    }

    pf.__pfCollectionPatched = true;
  }

  function safePatch(pf) {
    try { patch(pf); } catch (e) { console.error('Bilfilter for kolleksjon: kunne ikke aktivere kolleksjonsfilter', e); }
  }

  var stored = window._pfInstance;
  if (stored) safePatch(stored);

  try {
    Object.defineProperty(window, '_pfInstance', {
      configurable: true,
      get: function () { return stored; },
      set: function (v) { stored = v; safePatch(v); }
    });
  } catch (e) {
    console.error('Bilfilter for kolleksjon: kunne ikke koble til bilfilteret', e);
  }
})();
